import { render } from "./DeclineModal.vue?vue&type=template&id=469cd0dc"
import script from "./DeclineModal.vue?vue&type=script&lang=ts"
export * from "./DeclineModal.vue?vue&type=script&lang=ts"
script.render = render

export default script